import { z } from "zod"

export const DEFAULT_JOB_LABEL_COLOR = "#E5E7EB"

export const JobLabelSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  color: z.string(),
  isSystem: z.boolean(),
  /** The label is one of the store's leasing companies; its id is the company's. */
  isLeasingCompany: z.boolean(),
})

export const SaveJobLabelSchema = z.object({
  name: z.string().min(1),
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, "color must be a 6-digit hex code"),
})

export const UpdateJobLabelSchema = SaveJobLabelSchema.partial()

export const SetJobLabelsSchema = z.object({
  labelIds: z.array(z.string().uuid()),
})

export type JobLabel = z.infer<typeof JobLabelSchema>
export type SaveJobLabel = z.infer<typeof SaveJobLabelSchema>
export type UpdateJobLabel = z.infer<typeof UpdateJobLabelSchema>
export type SetJobLabels = z.infer<typeof SetJobLabelsSchema>
